// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bUek","type":"styles_type__2H-Od","choices":"styles_choices__1ikaa"};